export default __webpack_public_path__ + "static/media/close-icon.d5e5ff10.svg";